import { Component, Input } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';
import { ViewManager } from 'src/app/board/pages/admin/admin-components/custom-views-config/view-builder/models/view-builder.models';

@Component({
  selector: 'bhub-pdf-text-cell',
  standalone: false,
  templateUrl: './pdf-text-cell.component.html',
  styleUrls: ['./pdf-text-cell.component.scss']
})
export class PdfTextCellComponent extends BaseCellComponent {
  @Input() viewManager: ViewManager | null = null;

  displayText: string = '';
  fontSize: number = 12;
  fontWeight: string = 'normal';
  fontStyle: string = 'normal';
  textAlign: string = 'left';
  color: string = '#000000';

  protected initializeCell(): void {
    this.updateDisplayProperties();
  }

  protected onCellOrDataChange(): void {
    this.updateDisplayProperties();
  }

  protected onCellUpdate(): void {
    this.updateDisplayProperties();
  }

  protected onDataSet(data: any): void {
    this.updateDisplayProperties();
  }

  reloadData(): void {
    this.updateDisplayProperties();
  }

  private updateDisplayProperties(): void {
    if (!this.cell) return;

    this.displayText = this.getConfigValue('pdfValue', 'PDF Text');
    this.fontSize = this.getConfigValue('pdfFontSize', 12);
    this.fontWeight = this.getConfigValue('pdfFontWeight', 'normal');
    this.fontStyle = this.getConfigValue('pdfFontStyle', 'normal');
    this.textAlign = this.getConfigValue('pdfTextAlign', 'left');
    this.color = this.getConfigValue('pdfColor', '#000000');
  }
}
